import { useState, useEffect, useCallback } from "react";
import { isBrowser } from "./utils";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: isBrowser ? window?.innerWidth : null,
    height: isBrowser ? window?.innerHeight : null,
  });

  const handleResize = useCallback(() => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window?.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return windowSize;
}

export default useWindowSize;
